import { call, put } from "redux-saga/effects";
import { MQTTConnection, SocketConnection } from "../../../Connections/Socket/Socket";
import {
  WSConnectionErrorAction,
  WSConnectionSuccessAction,
  MQTTConnectionErrorAction,
  MQTTConnectionSuccessAction,
} from "../../Actions/Main/Actions";


export function* connectSocketSaga() {
  try {
    const startConnection = yield call(SocketConnection);
    yield put(WSConnectionSuccessAction(startConnection));
  } catch (error) {
    yield put(WSConnectionErrorAction(error));
  }
};

export function* connectMQTTSaga() {
  try {
    const mqttResponse = yield call(MQTTConnection);
    yield put(MQTTConnectionSuccessAction(mqttResponse));
  } catch (error) {
    yield put(MQTTConnectionErrorAction(error));
  }
};